import React from "react";
import * as d3 from "d3";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import "./styles.scss";
import dictionary from "../dictionary.js";

const isMobile = window.innerWidth < 800;
const margin = {
  top: isMobile ? 60 : 10,
  right: isMobile ? 10 : 90,
  bottom: isMobile ? 90 : 70,
  left: isMobile ? 50 : 90
};
const options = [
  { value: "V", label: "UDC" },
  { value: "S", label: "PS" },
  { value: "G", label: "Verts" },
  { value: "GL", label: "Vert'lib" },
  { value: "RL", label: "PLR" },
  { value: "CE", label: "PDC" },
  { value: "BD", label: "PBD" }
];

class Popup extends React.Component {
  getPosition() {
    const position = {
      x: this.props.data.x + margin.left + 20,
      y: this.props.data.y + margin.top + 40
    };

    // Orient the popup to the left or to the right
    if (position.x >= window.innerWidth / 2) {
      position.x = position.x - 240;
    }

    // Orient the popup to the top or to the bottom
    if (position.y >= this.props.container.clientHeight / 2) {
      position.y = position.y - 240;
    }

    if (position.x + 240 > window.innerWidth) {
      console.log("Right overlap");
      position.x = window.innerWidth - 260;
    } else if (position.x < 0) {
      position.x = 0;
    }

    return {
      x: position.x,
      y: position.y
    };
  }

  render() {
    return (
      <div
        className="chart-popup ui raised fitted segment"
        style={{
          left: this.getPosition().x,
          top: this.getPosition().y
        }}
      >
        <div>
          <img
            src={require("./../images/councillors/" +
              this.props.data["CouncillorId"] +
              ".png")}
          />
        </div>
        <div>
          <b>{this.props.data["CouncillorName"]}</b> (
          {this.props.data["Canton"]})<br />
          {
            dictionary.parliamentaryGroups[
              this.props.data["Groupe parlementaire"]
            ]
          }
          <br />
          {Math.round(this.props.data.score * 1000) / 10 + "%"} de votes
          identiques
        </div>
      </div>
    );
  }
}

class Beeswarm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedGroup: this.props.selectedGroup,
      selectedCircle: null
    };
    this.updateDimensions = this.updateDimensions.bind(this);
    this.getDimensions = this.getDimensions.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.popupTimeout = null;
  }

  handleMouseOver(e) {
    clearTimeout(this.popupTimeout);
    this.setState({
      selectedCircle: e
    });
  }

  handleMouseOut() {
    this.popupTimeout = setTimeout(() => {
      this.setState({
        selectedCircle: null
      });
    }, 1000);
  }

  handleTouchStart() {
    clearTimeout(this.popupTimeout);
    this.setState({
      selectedCircle: null
    });
  }

  drawChart(width, height) {
    let outerCircleRadius = isMobile ? 8 : 10;
    let innerCircleRadius = isMobile ? 4 : 6;

    this.svg = d3
      .select(this.node)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom);
    this.g = this.svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    this.axis = d3
      .scaleLinear()
      .rangeRound([0, isMobile ? height : width])
      .domain([isMobile ? 1 : 0, isMobile ? 0 : 1]);

    this.simulation = d3
      .forceSimulation(this.props.data)
      .force(
        "x",
        d3
          .forceX(d => {
            return isMobile ? width / 2 : this.axis(d.score);
          })
          .strength(isMobile ? 0.2 : 1)
      )
      .force(
        "y",
        d3
          .forceY(d => {
            return isMobile ? this.axis(d.score) : height / 2;
          })
          .strength(isMobile ? 1 : 0.2)
      )
      .force("collide", d3.forceCollide(outerCircleRadius))
      .stop();

    for (let i = 0; i < 120; ++i) this.simulation.tick();

    this.cell = this.g
      .append("g")
      .attr("class", "cells")
      .selectAll("g")
      .data(this.props.data)
      .enter()
      .append("circle")
      .attr("r", innerCircleRadius)
      .attr("cx", d => d.x)
      .attr("cy", d => d.y);

    this.cell
      .on("mouseover", this.handleMouseOver)
      .on("mouseout", this.handleMouseOut);

    if (isMobile) {
      // Grid
      this.g
        .append("g")
        .attr("class", "grid")
        .call(
          d3
            .axisLeft(this.axis)
            .ticks(5)
            .tickSize(-height)
            .tickFormat("")
        );

      // Ticks
      this.g
        .append("g")
        .attr("class", "axis axis--x")
        .call(
          d3
            .axisLeft(this.axis)
            .ticks(5)
            .tickFormat(d => {
              let tick = d === 1 ? "100%" : d * 100;
              return tick;
            })
        );

      // Annotations
      this.g
        .append("g")
        .append("text")
        .attr("text-anchor", "end")
        .attr("class", "chart-annotation")
        .attr("x", width)
        .attr("y", height + 50)
        .text("Éloignés ▼");

      this.g
        .append("g")
        .append("text")
        .attr("class", "chart-annotation")
        .attr("text-anchor", "end")
        .attr("x", width)
        .attr("y", -30)
        .text("Proches ▲");

      this.g
        .append("g")
        .append("text")
        .attr("class", "chart-label")
        .attr("text-anchor", "middle")
        .attr("transform", "rotate(-90)")
        .attr("x", -height / 2)
        .attr("y", -40)
        .text("Votes identiques aux vôtres");
    } else {
      // Grid
      this.g
        .append("g")
        .attr("class", "grid")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(this.axis)
            .ticks(5)
            .tickSize(-height)
            .tickFormat("")
        );

      // Ticks
      this.g
        .append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + height + ")")
        .call(
          d3
            .axisBottom(this.axis)
            .ticks(5)
            .tickFormat(d => {
              let tick = d === 1 ? "100%" : d * 100;
              return tick;
            })
        );

      // Annotations
      this.g
        .append("g")
        .append("text")
        .attr("class", "chart-annotation")
        .attr("text-anchor", "end")
        .attr("x", width + margin.right)
        .attr("y", 10)
        .text("Les plus proches ►");

      this.g
        .append("g")
        .append("text")
        .attr("class", "chart-label")
        .attr("text-anchor", "middle")
        .attr("x", width / 2)
        .attr("y", height + 50)
        .text("Proportion de votes identiques aux vôtres");
    }

    this.node.addEventListener("touchstart", this.handleTouchStart);
  }

  componentDidUpdate() {
    this.updateChart();
  }

  updateChart(height, width) {
    console.log("Update chart...");

    /* this.simulation = d3
      .forceSimulation(this.props.data)
      .force("x", d3.forceX(d => this.x(d.score)).strength(1))
      .force("y", d3.forceY(height / 2))
      .force("collide", d3.forceCollide(10))
      .stop();

    for (let i = 0; i < 120; ++i) this.simulation.tick(); */

    this.cell.attr("class", d => {
      if (d["Groupe parlementaire"] === this.state.selectedGroup) {
        return "active";
      }
    });

    /* this.cell
      .attr("cx", d => d.data.x)
      .attr("cy", d => d.data.y)
      .attr("class", d => d.data['Groupe parlementaire'] + " " + d.data['Canton']); */
  }

  getDimensions() {
    let width = this.node.parentNode.clientWidth - margin.left - margin.right;
    let height =
      (!isMobile ? (width * 2) / 4 : width * 2) - margin.top - margin.bottom;

    return {
      w: width,
      h: height
    };
  }

  updateDimensions() {
    let newDimensions = this.getDimensions();
    this.svg
      .attr("width", newDimensions.w + margin.left + margin.right)
      .attr("height", newDimensions.h + margin.top + margin.bottom);

    this.updateChart(newDimensions.w, newDimensions.h);
  }

  componentDidMount() {
    let initialDimensions = this.getDimensions();
    this.drawChart(initialDimensions.w, initialDimensions.h);
    this.updateChart();

    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  render() {
    return (
      <div className="beeswarm-container">
        <div className="key-label">
          Députés du groupe{" "}
          <Dropdown
            options={options}
            onChange={option => {
              this.props.handleGroupChange(option.value);
              this.setState({
                selectedGroup: option.value
              });
            }}
            value={this.state.selectedGroup}
            placeholder="Select an option"
          />
        </div>
        <div
          className="chart"
          ref={el => {
            this.node = el;
          }}
        />
        {this.state.selectedCircle && (
          <Popup container={this.node} data={this.state.selectedCircle} />
        )}
      </div>
    );
  }
}

export default Beeswarm;
